import React from 'react';
import Graphs from '../../utils/graphutil.js';
import Containers from '../../utils/containerutil.js';
import { Container} from '../components.js';

class GoalsDepCompleted extends React.Component {

	constructor(props) {
		super(props);

		this.chartToggle = this.chartToggle.bind(this);

		this.getDeposits = this.getDeposits.bind(this);
		this.getCompleted = this.getCompleted.bind(this);

		this.state = {	
						dgocChart : 'deposits',
						deposits : {data :{}, dataError: false}, 
						completedgoals : {data :{}, dataError: false} 
					};
	}

	componentDidMount() {
		
		if(this.state.deposits.data !== null && Object.keys(this.state.deposits.data).length === 0 && this.state.deposits.dataError === false) {
			this.getDeposits();
		}

		if(this.state.completedgoals.data !== null && Object.keys(this.state.completedgoals.data).length === 0 && this.state.completedgoals.dataError === false) {
			this.getCompleted();
		}
	}

	chartToggle(e) {
		if(this.state.dgocChart !== e)
			this.setState({dgocChart : e});
	}

	getDeposits() {
		var component = this;

		var callback = function(response) {
			if(response.code === 200) {
				if(response.detail !== "Report generated") {
					component.setState({ deposits : { data : response.data, dataError: response.detail}});
				}
				else {
					component.setState({deposits : {data : response.data, dataError: false}});
				}
			}
			else {
				component.setState({deposits: { data : {}, dataError: response}});

			}
		};

		window._fiSponsor.getDeposits(callback);
	}

	getCompleted() {
		var component = this;

		var callback = function(response) {
			if(response.code === 200) {
				if(response.detail !== "Report generated") {
					component.setState({ completedgoals : { data : response.data, dataError: response.detail}});
				}
				else {
					component.setState({completedgoals : {data : response.data, dataError: false}});
				}
			}
			else {
				component.setState({completedgoals: { data : {}, dataError: response}});

			}
		};

		window._fiSponsor.getCompletedGoals(callback);
	}

	render() {
		const depositsSize = {
			width: (this.props.size) ? this.props.size.width : '65vmin',
			height: (this.props.size) ? this.props.size.height : '55vmin'
		};

	  	var depositsChart 

	  	if(this.state.dgocChart === 'deposits') {
	  		depositsChart = (<div className="Chart-Body">{Containers.getContainerDisplay(this.state.deposits, Graphs.cumulative_deposits)}</div>);
	  	}
	  	else if (this.state.dgocChart === 'completedgoals') {
	  		depositsChart = (<div className="Chart-Body">{Containers.getContainerDisplay(this.state.completedgoals, Graphs.completed_goals)}</div>)
	  	}

	  	var note = (this.state.dgocChart === 'deposits') ? 'This is the total amount your users have deposited into Plinqit since your launch.' : 'This is the number of Plinqit goals users have completed each quarter.';

	  	var dgocContainerLabels = [
	  		{'label' : 'Cumulative Deposits', 'onClick': this.chartToggle, key: 'deposits', selected: (this.state.dgocChart === 'deposits')},
	  		{'label' : 'Goals Completed', 'onClick': this.chartToggle, key: 'completedgoals', selected : (this.state.dgocChart === 'completedgoals')} 
	  	];

  		return (
  			<Container key='deposits' 
  			moreClass={"Container-Stackable Container-Grow " + this.props.addClass} 
  			titles={dgocContainerLabels} titletype='toggle'
  			note={note} 
  			contents={depositsChart} size={depositsSize} onclick={this.props.onclick} bgcolor="rgb(100, 160, 67)" />
  		);
	}
}

export default GoalsDepCompleted;








